import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';
import { useRouter } from 'shared-routing';

import { RoomContainer } from './container';
import { RoomDetailV2 } from './v2';
import { RoomProps } from './Room.types';

export const RoomVersion: FC<RoomProps> = (props) => {
  const { query } = useRouter();
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2 && !query.bookingStep) return <RoomDetailV2 {...props} />;
  return <RoomContainer {...props} />;
};
